import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <span className="text-3xl font-bold text-white tracking-tight">
                istanbul<span className="text-orange-500">turda</span>
              </span>
            </Link>
            <p className="text-gray-400 mb-4 max-w-md">
              İstanbul'un tarihi ve kültürel zenginliklerini profesyonel rehber eşliğinde
              keşfedin. Benzersiz yürüyüş turlarımızla şehrin gizli köşelerini tanıyın.
            </p>
            <div className="flex flex-col space-y-3 text-sm">
              <a
                href="tel:+905414112373"
                className="flex items-center space-x-3 text-gray-400 hover:text-orange-500 transition-colors"
                data-testid="footer-phone"
              >
                <Phone size={18} />
                <span>+90 541 411 23 73</span>
              </a>
              <a
                href="mailto:info@istanbulturda.com"
                className="flex items-center space-x-3 text-gray-400 hover:text-orange-500 transition-colors"
                data-testid="footer-email"
              >
                <Mail size={18} />
                <span>info@istanbulturda.com</span>
              </a>
              <div className="flex items-start space-x-3 text-gray-400">
                <MapPin size={18} className="mt-1 flex-shrink-0" />
                <span>
                  Truva Villaları No:8, Esenkent Mh,<br />
                  Truva Evleri İçi Yolu, 34510 Esenkent<br />
                  Esenyurt / İstanbul
                </span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Hızlı Bağlantılar</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/turlar/istanbul" className="text-gray-400 hover:text-orange-500 transition-colors">
                  İstanbul Turları
                </Link>
              </li>
              <li>
                <Link to="/turlar/yurtici" className="text-gray-400 hover:text-orange-500 transition-colors">
                  Yurtiçi Turlar
                </Link>
              </li>
              <li>
                <Link to="/turlar/yurtdisi" className="text-gray-400 hover:text-orange-500 transition-colors">
                  Yurtdışı Turlar
                </Link>
              </li>
              <li>
                <Link
                  to="/istanbul-hikayeleri"
                  className="text-gray-400 hover:text-orange-500 transition-colors"
                >
                  İstanbul Hikayeleri
                </Link>
              </li>
              <li>
                <Link to="/hakkimizda" className="text-gray-400 hover:text-orange-500 transition-colors">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="text-gray-400 hover:text-orange-500 transition-colors">
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Popüler Turlar</h3>
            <ul className="space-y-3 text-sm text-gray-400">
              <li>Ayvansaray - Balat - Fener</li>
              <li>Levantenlerin İzinde</li>
              <li>Kapadokya Balon Turu</li>
              <li>Yunanistan Adaları</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800">
          {/* TÜRSAB Section */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-8">
            <a 
              href="https://www.tursab.org.tr/tr/ddsv" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center bg-white px-4 py-3 rounded-lg"
            >
              <img 
                src="https://www.tursab.org.tr/assets/images/tursab-50-logo.svg" 
                alt="TÜRSAB 50. Yıl" 
                className="h-14"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.parentElement.innerHTML = '<span style="color:#e53935;font-weight:bold;font-size:24px;">TÜRSAB</span>';
                }}
              />
            </a>
            <div className="text-center md:text-left">
              <p className="text-orange-500 font-bold text-lg">VIATERRA TRAVEL AGENCY</p>
              <p className="text-gray-400">TÜRSAB Belge No: <span className="text-white font-semibold">18741</span></p>
            </div>
          </div>
          
          <div className="text-center text-sm text-gray-400">
            <p>&copy; 2026 istanbulturda.com - Tüm hakları saklıdır. <button type="button" onClick={() => { localStorage.removeItem('cookie_consent'); window.location.reload(); }} className="underline hover:text-orange-400 ml-2" data-testid="footer-cookie-preferences">Çerez Tercihleri</button></p>
            <p className="mt-2">VIATERRA TRAVEL AGENCY - TÜRSAB: 18741</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
